import { useEffect, useState } from "react";
import axios from "axios";
import MetaComponent from "../../components/MetaComponent.js";

import { styled } from '@mui/material/styles';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Rating from '@mui/material/Rating';
import Typography from '@mui/material/Typography';
import Switch from '@mui/material/Switch';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import CircularProgress from '@mui/material/CircularProgress';
import useMediaQuery from '@mui/material/useMediaQuery';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';

import AdminMenuComponent from "../../components/admin/AdminMenuComponent.js";
import ProductCardComponent from "../../components/ProductCardComponent.js";

const config = require("../../constants/constants.js")

const ProdottiPageComponent = ({ categories, getBestsellers }) => {

  const [applicativo, setApplicativo] = useState("");
  const [isShopActive, setIsShopActive] = useState("");
  const [isIconLoginActive, setIsIconLoginActive] = useState("");
  const [isApplicationWorkInProgress, setIsApplicationWorkInProgress] = useState("");
  const [showMainMenuUppercase, setShowMainMenuUppercase] = useState("");

  const [isBreadcrumbActive, setIsBreadcrumbActive] = useState("");
  const [breadcrumbsBackgroud, setBreadcrumbsBackgroud] = useState("");
  const [breadcrumbsColor, setBreadcrumbsColor] = useState("");
  const [menuBackground, setMenuBackground] = useState("");
  const [menuColor, setMenuColor] = useState("");
  const [menuMobileColor, setMenuMobileColor] = useState("");

  const getConfigByProgressivoApiRequest = async (progressivoRagSoc) => {
    //console.log("[getConfigByProgressivoApiRequest] leggo const con progressivo =", progressivoRagSoc);
    const url = `/api/configs/progressivo/` + progressivoRagSoc;
    const { data } = await axios.get(url);
    return data
  }

  useEffect(() => {
    getConfigByProgressivoApiRequest('0001').then((data) => {
      //console.log(`data =`, data);
      setApplicativo(data?.applicativo);
      setIsShopActive(data?.isShopActive);
      setIsIconLoginActive(data?.isIconLoginActive);
      setIsApplicationWorkInProgress(data?.isApplicationWorkInProgress);
      setShowMainMenuUppercase(data?.showMainMenuUppercase);
      setIsBreadcrumbActive(data?.isBreadcrumbActive);
      setBreadcrumbsBackgroud(data?.breadcrumbsBackgroud);
      setBreadcrumbsColor(data?.breadcrumbsColor);
      setMenuBackground(data?.menuBackground);
      setMenuColor(data?.menuColor);
      setMenuMobileColor(data?.menuMobileColor);
       //console.log(`data?.applicativo =`, data?.applicativo);
      //console.log(`data?.linkWhatsapp =`, data?.linkWhatsapp);
      //console.log(`data?.linkFacebook =`, data?.linkFacebook);
      //console.log(`data?.linkInstagram =`, data?.linkInstagram);
      //console.log(`data?.linkTwitter =`, data?.linkTwitter);
      //console.log(`ragioneSociale =`, data?.ragioneSociale);
      //console.log(`urlCustomerImageServer =`, data?.urlCustomerImageServer);
      //console.log(`isShopActive =`, data?.isShopActive);
      //console.log(`isIconLoginActive =`, data?.isIconLoginActive);
      //console.log(`isApplicationWorkInProgress =`, data?.isApplicationWorkInProgress);
    })
      .catch((er) => {
        console.log(er);
      });
  }, [applicativo, isShopActive, showMainMenuUppercase])

  const [mainCategories, setMainCategories] = useState([]);
  const [bestSellers, setBestsellers] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    getBestsellers()
      .then((data) => {
        console.log("[prod] data =", mainCategories);
        setBestsellers(data);
      })
      .catch((er) => {
        setError(er.response.data.message ? er.response.data.message : er.response.data)
        console.log(er.response.data.message ? er.response.data.message : er.response.data)
      });
    setMainCategories((cat) => categories.filter((item) => !item.name.includes("/")));
    console.log("[prod] mainCategories =", mainCategories);

  }, [categories])

  return (

    <>

      {/* 
        <MetaComponent />
      */}

      <Box sx={{ flexGrow: 1 }}>

        <AdminMenuComponent></AdminMenuComponent>

      <Grid
        display={isBreadcrumbActive === 'Si' ? "block" : "none"}
        container
        size={{ xs: 12, md: 12 }}
        paddingTop={{ xs: 0, md: 0 }}
        paddingLeft={{ xs: 0, md: 0 }}
        paddingRight={{ xs: 0, md: 0 }}
        spacing={{ xs: 0, md: 0 }}
        sx={{
          //background: '#242424',        // sfondo mainMenu = nero 
          //background: '#2074d4'         // sfondo mainMenu = blu navy
          background: breadcrumbsBackgroud  // sfondo mainMenu = da configs
        }}
      >
        <Breadcrumbs
          separator="›"
          aria-label="breadcrumb"
          size={{ xs: 12, md: 4 }}
          paddingTop={{ xs: 0, md: 0 }}
          paddingLeft={{ xs: 8, md: 17 }}   // per posizione dopo logo di sx
          paddingRight={{ xs: 1, md: 0 }}
          spacing={{ xs: 0, md: 0 }}
          color="white"
          //fontFamily="Roboto"
          fontFamily="sans-serif"
          textTransform='none'
          fontSize={14}
          //fontStyle= 'italic'
          //fontWeight= {100}
        >

          <Link underline="hover" color="inherit" href="/">
            <HomeOutlinedIcon />
          </Link>

          <Typography
            sx={{
              color: 'white',
              fontFamily:"sans-serif",
              textTransform:'none',
              fontSize:14,
            }}
          >
            {config.BC_PRODOTTI}
          </Typography>

        </Breadcrumbs>
      </Grid>


      {/* 
        <Box
          display={isBreadcrumbActive === 'Si' ? "block" : "none"}
        >
          <Breadcrumbs separator="›" aria-label="breadcrumb"
            size={{ xs: 12, md: 4 }}
            paddingTop={{ xs: 1, md: 1 }}
            paddingLeft={{ xs: 2, md: 8 }}
            paddingRight={{ xs: 1, md: 8 }}
            spacing={{ xs: 2, md: 2 }}
          >
            <Link underline="hover" color="inherit" href="/">
              <Typography
                sx={{
                  color: 'text.primary',
                  fontFamily: 'Roboto',
                  textTransform: 'none',
                  fontSize: 14,
                }}
              >
                {config.BC_HOME}
              </Typography>
            </Link>
            <Typography
              sx={{
                color: 'text.primary',
                fontFamily: 'Roboto',
                textTransform: 'none',
                fontSize: 14,
              }}
            >
              {config.BC_PRODOTTI}
            </Typography>
          </Breadcrumbs>
        </Box>
      */}

        <Grid
          container
          size={{ xs: 12, md: 4 }}
          paddingTop={{ xs: 1, md: 3 }}
          paddingLeft={{ xs: 2, md: 8 }}
          paddingRight={{ xs: 1, md: 8 }}
          spacing={{ xs: 2, md: 2 }}
        >

          {mainCategories.map((category, idx) => (

            <ProductCardComponent key={idx} category={category} idx={idx} />

          ))}

        </Grid>

      </Box>

      <Box sx={{ m: 4 }} >
        &nbsp;
      </Box>

    </>

  );
};

export default ProdottiPageComponent;
